import { gql } from "@apollo/client";

export const HIDE_LISTING_MUTATION = gql`
  mutation HideListing($input: HideOrUnhideProperty!) {
    hide_property(input: $input) {
      ... on HideOrUnhidePropertyErrors {
        errors {
          message
          type
        }
      }
      ... on HideOrUnhidePropertyResult {
        successful
      }
    }
  }
`;

export const UNHIDE_LISTING_MUTATION = gql`
  mutation UnhideListing($input: HideOrUnhideProperty!) {
    unhide_property(input: $input) {
      ... on HideOrUnhidePropertyErrors {
        errors {
          message
          type
        }
      }
      ... on HideOrUnhidePropertyResult {
        successful
      }
    }
  }
`;
